export default {
    common: {
        data_ethics_canvas: 'Datenethikmuster',
    },
};
